import { render } from "./AssignStudentsToGroup.vue?vue&type=template&id=c6ccdff6&scoped=true"
import script from "./AssignStudentsToGroup.vue?vue&type=script&lang=js"
export * from "./AssignStudentsToGroup.vue?vue&type=script&lang=js"

import "./AssignStudentsToGroup.vue?vue&type=style&index=0&id=c6ccdff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6ccdff6"]])

export default __exports__